// 导入基本公共资源
import http from "./../../../base/api/public";

let sysConfig = require("@/../config/sysConfig");
let service = require("@/../config/serviceList");
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre;
export default {

  getList(params) {
    return http.requestPost(`${apiPre}/res/gunBox/api/getList`, params);
  },
  getEnum() {
    return http.requestGet(`${apiPre}/res/gunBox/api/getEnum`);
  },
  insert(params) {
    return http.requestPost(`${apiPre}/res/gunBox/api/insert`, params);
  },
  update(params) {
    return http.requestPost(`${apiPre}/res/gunBox/api/update`, params);
  },
  deleteById(params) {
    return http.requestGet(`${apiPre}/res/gunBox/api/deleteById/${params}`);
  },
};



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/gunBox.js